import _ from 'lodash'
import {
  cachedConnect as connect,
} from './helpersHOC'
import MinionList from '../components/MinionList'

import { normalizeMinions } from '../saltapi/commonUtils'

export default connect((state, props, { cachedState }) => {
  let changed = false
  let minions = normalizeMinions(state.api._minions, state.api._keys)

  if (!changed &&
      _.size(cachedState.minions) !== _.size(minions))
    changed = true

  if (!changed &&
      _
        .chain(cachedState.minions)
        .filter('status')
        .size().value() !== _
          .chain(minions)
          .filter('status')
          .size().value())
    changed = true

  if (!changed &&
      _
        .chain(cachedState.minions)
        .filter('fingerprint')
        .size().value() !== _
          .chain(minions)
          .filter('fingerprint')
          .size().value())
    changed = true


  if (!changed &&
      _
        .chain(cachedState.minions)
        .filter('grains')
        .size().value() !== _
          .chain(minions)
          .filter('grains')
          .size().value())
    changed = true

  if (changed)
    cachedState = { minions }
  return cachedState
})(MinionList)



// WEBPACK FOOTER //
// ./src/containers/MinionList.js